import create from 'zustand';

import { Conversation } from '@/global/chat/types';

interface ConversationState {
  selectedConversation?: Conversation;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  setSelectedConversation: (conversation?: Conversation) => void;
}

const useConversationStore = create<ConversationState>((set) => ({
  selectedConversation: undefined,
  isOpen: false,
  setIsOpen: (isOpen) => set({ isOpen: isOpen }),
  setSelectedConversation: (conversation) =>
    set({ selectedConversation: conversation }),
}));

export default useConversationStore;
